// extracted by mini-css-extract-plugin
export default {"wrapper":"Placement_wrapper__IDiNM","card1":"Placement_card1__Y1EEx","card2":"Placement_card2__E0XXg"};